import React from 'react'
import CoursesApp from '../../features/course/Courses'
export default function Courses() {
  return (<CoursesApp/>)
}
